
if (jQuery(".arc-page").length > 0) {

    window.onbeforeunload = function () {
        window.scrollTo(0, 0);
    }

    //CHANGE WORD

     const changeWord = document.querySelector('.change-word');
    if (jQuery(".change-word").length > 0) {

        const transforms = [
            "trasforma",
            "evolve",
            "cambia"
        ];
        changeWords(changeWord, transforms);


        function changeWords(element, changeWords) {

            const WORD_CHANGE_DELAY = 2000;


            var wordChangeIndex = 0;


            setInterval(nextWord, WORD_CHANGE_DELAY);


            function nextWord() {

                wordChangeIndex++;
                if (wordChangeIndex === changeWords.length) {
                    wordChangeIndex = 0;
                }
                const changeWord = changeWords[wordChangeIndex];

                element.textContent = changeWord;
                element.setAttribute("data-text", changeWord);


            }
        }
    }




//TYPER
    const text = document.querySelector('.typing-text');


    const words = [
        "contatti",
        "contacts",
        "kontakte",
        "contactos",
        "联系方式",
    ];

    setTyper(text, words);

    function setTyper(element, words) {

        const LETTER_TYPE_DELAY = 50;
        const WORD_STAY_DELAY = 2000;

        const DIRECTION_FORWARDS = 0;
        const DIRECTION_BACKWARDS = 1;

        var direction = DIRECTION_FORWARDS;
        var wordIndex = 0;
        var letterIndex = 0;

        var wordTypeInterval;

        startTyping();

        function startTyping() {
            wordTypeInterval = setInterval(typeLetter, LETTER_TYPE_DELAY);
        }

        function typeLetter() {
            const word = words[wordIndex];

            if (direction === DIRECTION_FORWARDS) {
                letterIndex++;

                if (letterIndex === word.length) {
                    direction = DIRECTION_BACKWARDS;
                    clearInterval(wordTypeInterval);
                    setTimeout(startTyping, WORD_STAY_DELAY);
                }

            } else if (direction === DIRECTION_BACKWARDS) {
                letterIndex--;

                if (letterIndex === 0) {
                    nextWord();
                }
            }

            const textToType = word.substring(0, letterIndex);

            element.textContent = textToType;
        }

        function nextWord() {

            letterIndex = 0;
            direction = DIRECTION_FORWARDS;
            wordIndex++;

            if (wordIndex === words.length) {
                wordIndex = 0;
            }

        }
    }

}


